
import '../css/footer.css'
import whatsapp from '../img/icons8-whatsapp-50.png'
import instagram from '../img/icons8-instagram-50.png'
import facebook from '../img/facebook.png'
import paleta from '../img/image.png'

const Footer = () => {
  return (
    <div className='footerContainer'>
      <h2 className='h2Footer'>ELSA <br></br> DOMMARCO</h2>
      <div className='socialMediaFooter'>
        <a href='https://wa.me/5491141820595' target='blank'><img src={whatsapp} alt='whatsapp' /></a>
        <a href='https://www.facebook.com/elsa.dommarco' target='blanck'><img src={facebook} alt='facebook' /></a>
        <a href='https://www.instagram.com/dommarcoelsa/' target='blanck'><img src={instagram} alt='instagram' /></a>
      </div>
      <div className='imgCont'><img className='paletaFooter' src={paleta} alt='logo' />
      </div>
    </div>
  )
}

export default Footer